import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "cancel-booking-modal-label"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Why are you deleting this booking?", -1)
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = ["disabled"]

import $ from 'jquery';
import { ref, computed, inject } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment-timezone';
import { Booking, Dictionary } from '@/models';
import { useToast } from "vue-toastification";

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingCancelModal',
  props: {
  name: {
    type: String,
    default: ''
  }
},
  emits: ['hide'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;
const store = useStore();
const dictionary = computed((): Dictionary => store.getters['dictionary/current']);
const realtime: any = inject('realtime');
const actProperty: any = inject('actProperty');
const channel = realtime.channels.get('diary');
// Reactive state for the component
const booking = ref(new Booking());
const title = ref("");
const cancelnotes = ref('');
const emit = __emit;
const toasted = useToast();

// Initialize your booking
const init = (bookingData: Booking) => {
  booking.value = bookingData;
  cancelnotes.value = moment().format("DD/MM/YYYY");
  title.value = actProperty.getBookingTitle(booking.value, dictionary.value);
};

const getBooking = (payload: { id: string, cancelled: string }): Promise<any> =>
  store.dispatch('diary/getBookingWithoutStoringInState', payload);
const cancelBookingInStore = (booking: Booking): Promise<any> =>
  store.dispatch('diary/cancelBooking', booking);
const setBookingDeep = async (payload: {
  path: string;
  data: any;
}) => {
  await store.dispatch('diary/setBookingDeep', payload);
}

const cancelAllowed = computed(() => {
  return cancelnotes.value.length > 0;
});

const isCancelling = ref(false);
const bookingstocancel = ref(new Map<string, Booking>());
const cancel = async () => {
  isCancelling.value = true;
  booking.value.cancelnotes = cancelnotes.value;
  cancelBookingInStore(booking.value)
    .then(() => {
      channel.publish('appointmentCancelled', booking.value.id);
      isCancelling.value = false;
      hide(true);
      toasted.success("Booking deleted");
    })
    .then(() => {
      // Clear connectedbookingflag
      setBookingDeep({ path: 'connectedbooking', data: '' });
    })
    .then(async () => {
      // Cancel all subbookings
      if (booking.value.subbookings.length) {
        bookingstocancel.value = new Map();
        await getsubbookings(booking.value);
        for (let [id, b] of bookingstocancel.value) {
          cancelBookingInStore(b);
        }
      }
    })
    .catch((err: any) => {
      isCancelling.value = false;
      hide(false);
      actProperty.displayError(err);
    });
}

const getsubbookings = async (booking: Booking) => {
  bookingstocancel.value.set(booking.id, booking);
  if (booking.subbookings.length) {
    for (let i = 0; i < booking.subbookings.length; i++) {
      let sb: Booking = booking.subbookings[i];
      if (sb.id) {
        await getsubbookings(sb);
      }
      else {
        let b: Booking = await getBooking({ id: booking.id, cancelled: 'false' });
        await getsubbookings(b);
      }
    }
  }
}
const show = () => {
  if ($(`#${props.name}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.name + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.name}`).show();
  }
}
const hide = (val: boolean) => {
  if ($(`#${props.name}`).length > 0) {
    $(`#${props.name}` + 'Backdrop').remove();
    $(`#${props.name}`).hide();
    emit('hide', val, booking.value);
  }
};

__expose({ init, show, hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    id: __props.name,
    "aria-labelledby": "`cancel-booking-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, "Delete " + _toDisplayString(title.value), 1),
          _createElementVNode("button", {
            id: "close",
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide(false)), ["prevent"]))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              rows: "3",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cancelnotes).value = $event))
            }, null, 512), [
              [_vModelText, cancelnotes.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (hide(false)), ["prevent"]))
          }, " Back "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-danger",
            "data-dismiss": "modal",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (cancel()), ["prevent"])),
            disabled: isCancelling.value || !cancelAllowed.value
          }, " Delete Job ", 8, _hoisted_11)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})